export default [
	{  // 优惠券列表
		path: 'coupon_list',
		name: 'm_coupon_info',
		props: route => route.query,
		component: () => import('@/pages/marketing/coupon_list')
	},  {  // 新建优惠券
		path: 'coupon_add',
		name: 'coupon_add',
		meta: {
			title: '新建优惠券'
		},
		component: () => import('@/pages/marketing/coupon_add')
	},  {  // 编辑优惠券
		path: 'coupon_edit/:id',
		name: 'coupon_edit',
		meta: {
			title: '编辑优惠券'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_edit')
	},  {  // 优惠券详情
		path: 'coupon_detail/:id',
		name: 'coupon_detail',
		meta: {
			title: '优惠券详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_detail')
	},  {  // 优惠券审核
		path: 'coupon_verify/:id',
		name: 'coupon_verify',
		meta: {
			title: '优惠券审核'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_verify')
	}, {  // 优惠券发放任务
		path: 'coupon_task',
		name: 'm_coupon_task',
		props: route => route.query,
		component: () => import('@/pages/marketing/coupon_task')
	},  {  // 新建发放任务
		path: 'coupon_task_add',
		name: 'coupon_task_add',
		meta: {
			title: '新建发放任务'
		},
		component: () => import('@/pages/marketing/coupon_task_add')
	},  {  // 编辑发放任务
		path: 'coupon_task_edit/:id',
		name: 'coupon_task_edit',
		meta: {
			title: '编辑发放任务'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_task_edit')
	},  {  // 发放任务详情
		path: 'coupon_task_detail/:id',
		name: 'coupon_task_detail',
		meta: {
			title: '发放任务详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_task_detail')
	},  {  // 发放任务审核
		path: 'coupon_task_verify/:id',
		name: 'coupon_task_verify',
		meta: {
			title: '发放任务审核'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_task_verify')
	}, {  // 满赠活动列表
		path: 'reward_gift',
		name: 'm_activity_gifts',
		component: () => import('@/pages/marketing/reward_gift')
	},  {  // 新建满赠活动
		path: 'reward_gift_add',
		name: 'reward_gift_add',
		meta: {
			title: '新建满赠活动'
		},
		component: () => import('@/pages/marketing/reward_gift_add')
	},  {  // 编辑满赠活动
		path: 'reward_gift_edit/:id',
		name: 'reward_gift_edit',
		meta: {
			title: '编辑满赠活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/reward_gift_edit')
	},  {  // 满赠活动详情
		path: 'reward_gift_detail/:id',
		name: 'reward_gift_detail',
		meta: {
			title: '满赠活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/reward_gift_detail')
	}, {  // 限时折扣活动列表
		path: 'limit_time_discount',
		name: 'm_limit_time_discount',
		component: () => import('@/pages/marketing/limit_time_discount')
	},  {  // 新建限时折扣活动
		path: 'limit_time_discount_add',
		name: 'limit_time_discount_add',
		meta: {
			title: '新建限时折扣活动'
		},
		component: () => import('@/pages/marketing/limit_time_discount_add')
	},  {  // 编辑限时折扣活动
		path: 'limit_time_discount_edit/:id',
		name: 'limit_time_discount_edit',
		meta: {
			title: '编辑限时折扣活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/limit_time_discount_edit')
	},  {  // 限时折扣活动详情
		path: 'limit_time_discount_detail/:id',
		name: 'limit_time_discount_detail',
		meta: {
			title: '限时折扣活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/limit_time_discount_detail')
	}, {  // 砍价活动列表
		path: 'activity_bargain',
		name: 'm_activity_bargain',
		component: () => import('@/pages/marketing/activity_bargain')
	},  {  // 新建砍价活动
		path: 'activity_bargain_add',
		name: 'activity_bargain_add',
		meta: {
			title: '新建砍价活动'
		},
		component: () => import('@/pages/marketing/activity_bargain_add')
	},  {  // 编辑砍价活动
		path: 'activity_bargain_edit/:id',
		name: 'activity_bargain_edit',
		meta: {
			title: '编辑砍价活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_bargain_edit')
	},  {  // 砍价活动详情
		path: 'activity_bargain_detail/:id',
		name: 'activity_bargain_detail',
		meta: {
			title: '砍价活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_bargain_detail')
	},{  //预售活动列表
		path: 'activity_presell',
		name: 'm_activity_presell',
		component: () => import('@/pages/marketing/activity_presell')
	},  {  // 新建预售活动
		path: 'activity_presell_add',
		name: 'activity_presell_add',
		meta: {
			title: '新建预售活动'
		},
		component: () => import('@/pages/marketing/activity_presell_add')
	},  {  // 编辑预售活动
		path: 'activity_presell_edit/:id',
		name: 'activity_presell_edit',
		meta: {
			title: '编辑预售活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_presell_edit')
	},  {  // 预售活动详情
		path: 'activity_presell_detail/:id',
		name: 'activity_presell_detail',
		meta: {
			title: '预售活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_presell_detail')
	},
	{  //秒杀活动列表
		path: 'activity_secondkill',
		name: 'm_activity_secondkill',
		component: () => import('@/pages/marketing/activity_secondkill')
	},  {  // 新建秒杀活动
		path: 'activity_secondkill_add',
		name: 'activity_secondkill_add',
		meta: {
			title: '新建秒杀活动'
		},
		component: () => import('@/pages/marketing/activity_secondkill_add')
	},  {  // 编辑秒杀活动
		path: 'activity_secondkill_edit/:id',
		name: 'activity_secondkill_edit',
		meta: {
			title: '编辑秒杀活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_secondkill_edit')
	},  {  // 秒杀活动详情
		path: 'activity_secondkill_detail/:id',
		name: 'activity_secondkill_detail',
		meta: {
			title: '秒杀活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_secondkill_detail')
	},{  // 积分兑换
		path: 'pionts_product',
		name: 'm_points_product',
		component: () => import('@/pages/marketing/pionts_product')
	},{  // 分享赚
		path: 'share_award',
		name: 'm_share_award',
		component: () => import('@/pages/marketing/share_award_product')
	}, {  // 积分规则
		path: 'pionts_rule_config',
		name: 'm_points_regulation',
		component: () => import('@/pages/marketing/pionts_rule_config')
	}, {  // 积分管理明细
		path: 'pionts_record',
		name: 'm_points_recort',
		component: () => import('@/pages/marketing/pionts_record')
	}, {  //拼团活动列表
		path: 'activity_group',
		name: 'm_activity_group',
		component: () => import('@/pages/marketing/activity_group')
	},  {  // 新建拼团活动
		path: 'activity_group_add',
		name: 'activity_group_add',
		meta: {
			title: '新建拼团活动'
		},
		component: () => import('@/pages/marketing/activity_group_add')
	},  {  // 编辑拼团活动
		path: 'activity_group_edit/:id',
		name: 'activity_group_edit',
		meta: {
			title: '编辑拼团活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_group_edit')
	},  {  //拼团活动详情
		path: 'activity_group_detail/:id',
		name: 'activity_group_detail',
		meta: {
			title: '拼团活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_group_detail')
	},  {  // 成团审批
		path: 'activity_group_approve/:id',
		name: 'activity_group_approve',
		meta: {
			title: '拼团活动成团审批'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_group_approve')
	}, {  // 新人活动列表
		path: 'activity_new',
		name: 'm_activity_new',
		component: () => import('@/pages/marketing/activity_new')
	},  {  // 新建新人活动
		path: 'activity_new_add',
		name: 'activity_new_add',
		meta: {
			title: '新建新人活动'
		},
		component: () => import('@/pages/marketing/activity_new_add')
	},  {  // 编辑新人活动
		path: 'activity_new_edit/:id',
		name: 'activity_new_edit',
		meta: {
			title: '编辑新人活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_new_edit')
	},  {  // 新人活动详情
		path: 'activity_new_detail/:id',
		name: 'activity_new_detail',
		meta: {
			title: '新人活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_new_detail')
	}, {  // 健康活动列表
		path: 'offline_activity',
		name: 'm_offline_activity',
		component: () => import('@/pages/marketing/offline_activity')
	},  {  // 新建健康活动活动
		path: 'offline_activity_add',
		name: 'offline_activity_add',
		meta: {
			title: '新建健康活动'
		},
		component: () => import('@/pages/marketing/offline_activity_add')
	},  {  // 编辑健康活动
		path: 'offline_activity_edit/:id',
		name: 'offline_activity_edit',
		meta: {
			title: '编辑健康活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/offline_activity_edit')
	},  {  // 健康活动详情
		path: 'offline_activity_detail/:id',
		name: 'offline_activity_detail',
		meta: {
			title: '健康活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/offline_activity_detail')
	}, {  // 健康活动报名记录列表
		path: 'offline_activity_apply/:id',
		name: 'm_offline_activity_apply',
		meta: {
			title: '健康活动报名记录'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/offline_activity_apply_list')
	},{  // 积分抽奖配置
		path: 'pionts_lottery',
		name: 'm_lottery_award_config',
		component: () => import('@/pages/marketing/lottery_config.vue')
	}, {  // 抽奖记录查询
		path: 'lottery_win_record',
		name: 'm_lottery_win_record',
		component: () => import('@/pages/marketing/lottery_win_record')
	},  {  // 抽奖记录详情
		path: 'lottery_win_record_detail/:id',
		name: 'lottery_win_record_detail',
		meta: {
			title: '抽奖记录详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/lottery_win_record_detail')
	},{  // 礼品卡任务列表
		path: 'gift_card_task_list',
		name: 'm_gift_card_task',
		props: route => route.query,
		component: () => import('@/pages/marketing/gift_card_task')
	},{  // 礼品卡列表
		path: 'gift_card_list',
		name: 'm_gift_card_list',
		props: route => route.query,
		component: () => import('@/pages/marketing/gift_card_list')
	}
];